var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.2025C17.5012 4.76449 17.4154 4.33059 17.2478 3.92593C17.0801 3.52127 16.8339 3.15387 16.5233 2.845L14.655 0.976667C14.0289 0.353199 13.1819 0.00218954 12.2983 0L5 0C4.33696 0 3.70107 0.263392 3.23223 0.732233C2.76339 1.20107 2.5 1.83696 2.5 2.5V20H17.5V5.2025ZM15.345 4.02333C15.3869 4.0688 15.4261 4.11666 15.4625 4.16667H13.3333V2.0375C13.3833 2.07387 13.4312 2.1131 13.4767 2.155L15.345 4.02333ZM4.16667 18.3333V2.5C4.16667 2.27899 4.25446 2.06702 4.41074 1.91074C4.56703 1.75446 4.77899 1.66667 5 1.66667H11.6667V5.83333H15.8333V18.3333H4.16667ZM6.66667 7.5H13.3333V9.16667H6.66667V7.5ZM6.66667 10.8333H13.3333V12.5H6.66667V10.8333ZM11.6817 14.0117L13.3192 14.3167C13.16 15.1892 12.4817 16.6667 10.9458 16.6667C10.343 16.6661 9.75871 16.4584 9.29083 16.0783C9.02917 15.8925 8.9375 15.8333 8.73917 15.8333C8.44084 15.9465 8.17757 16.1362 7.97583 16.3833L6.72583 15.2858C7.2299 14.67 7.95 14.2697 8.73917 14.1667C9.29319 14.1733 9.82842 14.3684 10.2567 14.72C10.4434 14.896 10.6892 14.9959 10.9458 15C11.465 15 11.6792 14.0225 11.6817 14.0117Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.9b3c2535.svg";
export { ForwardRef as ReactComponent };